import {Button, ButtonProps} from '@shortsworks/ui/components/ui/button';
import {ReactNode} from 'react';
import {LoaderCircle} from 'lucide-react';

export interface LoadingButtonProps extends ButtonProps {
  loading?: boolean;
  loadingIndicator?: string | ReactNode;
}

export const LoadingButton = ({ loading, loadingIndicator, children, ...props }: LoadingButtonProps) => (
  <Button {...props} disabled={loading}>
    {loading ? (loadingIndicator || <LoaderCircle className="w-6 h-6 mr-2 animate-spin" />) : children}
  </Button>
)
